<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {UrlUtil} from "../../lib/Common/Http/UrlUtil";
    import LoadingContentView from "../../component/common/Loading/LoadingContentView.svelte";
    import {HttpRequestUtil} from "../../lib/Common/Http/HttpRequestUtil";
    import SpaceManagementLinkView from "./SpaceManagementLinkView.svelte";
    import SpaceInformationView from "./SpaceInformationView.svelte";
    import SpaceUserTrackingView from "../Tracking/SpaceUserTrackingView.svelte";

    const dispatcher = createEventDispatcher();


    export let spaceUniqueId;
    export let isShowNotFoundMessage = false;

    export let loadAdditionalParamMap = [];
    export let pageTrailMap = null;


    let space = null;

    onMount(() => {
        loadData();
    });

    let isLoading = false;
    let isLoaded = false;


    function loadData() {
        const paramMap = {};
        paramMap['unique_id'] = spaceUniqueId;

        // 必須オプション
        paramMap['include_icon_s3_url'] = undefined;
        paramMap['include_space_advance_settings'] = undefined;
        paramMap['include_most_strong_authority_type'] = undefined;

        // 追加パラメーター
        for (let key in loadAdditionalParamMap) {
            const value = loadAdditionalParamMap[key];
            paramMap[key] = value;
        }

        const url = UrlUtil.createApiUrl("space", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            isLoaded = true;
            console.log(response);
            const body = response['body'];
            const spaces = body['spaces'];

            if (spaces.length > 0) {
                space = spaces[0];
            } else {
                space = null;
            }

            dispatcher('load', {space: space});

        });
    }


</script>


<LoadingContentView isLoading={isLoading}>
    {#if space != null}
        <slot/>

        <SpaceInformationView space={space} pageTrailMap={pageTrailMap}/>

        <SpaceManagementLinkView space={space}/>

        <SpaceUserTrackingView space={space}/>
    {:else}
        {#if isLoaded}
            {#if isShowNotFoundMessage}
                <div class="not-found-message">
                    <h1>
                        { spaceUniqueId } のスペースが見つかりません
                    </h1>
                    <div class="description">
                        以下の理由が考えられます。

                        <ul>
                            <li>存在しないスペースを指定している</li>
                            <li>権限がない</li>
                            <li>許可されたアクセス元IPではない</li>
                            <li>部署異動により、部署権限がなくなった</li>
                        </ul>
                    </div>

                </div>
            {/if}
        {/if}
    {/if}
</LoadingContentView>


<style lang="scss">

    .not-found-message {
        padding: 60px;

        .description {
            opacity: 0.5;
        }
    }

</style>